import { SEO } from "@/components/SEO";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";

const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="Conditions Générales d'Utilisation - Château de Clémentine"
        description="Conditions générales d'utilisation pour la location de châteaux gonflables et sumos en Belgique."
        canonicalUrl="https://chateaudeclementine.com/terms-of-service"
      />
      
      {/* Header */}
      <div className="bg-gradient-sky py-16">
        <div className="container mx-auto px-4">
          <Link to="/">
            <Button variant="ghost" className="mb-6">
              <ArrowLeft className="w-4 h-4 mr-2" />
              Retour à l'accueil
            </Button>
          </Link>
          <h1 className="text-4xl md:text-5xl font-display font-bold text-foreground">
            Conditions Générales d'Utilisation
          </h1>
          <p className="text-xl text-muted-foreground mt-4">
            Dernière mise à jour : {new Date().toLocaleDateString('fr-FR')}
          </p>
        </div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 py-16">
        <div className="max-w-4xl mx-auto prose prose-lg">
          
          <h2>1. Présentation de l'entreprise</h2>
          <p>
            <strong>Château de Clémentine</strong><br />
            Avenue de la Rosée 12<br />
            1640 Rhode-Saint-Genèse, Belgique<br />
            Email : lechateaudeclementine@gmail.com<br />
            Téléphone : +32-123-45-67-89<br />
            Numéro d'entreprise : BE 0123.456.789
          </p>

          <h2>2. Objet</h2>
          <p>
            Les présentes conditions générales régissent l'utilisation du site web et les services de location 
            de châteaux gonflables et sumos proposés par Château de Clémentine.
          </p>

          <h2>3. Services proposés</h2>
          <p>
            Château de Clémentine propose la location de :
          </p>
          <ul>
            <li>Châteaux gonflables de différents thèmes et tailles</li>
            <li>Costumes de sumo gonflables</li>
            <li>Accessoires et équipements de sécurité associés</li>
          </ul>

          <h2>4. Processus de réservation</h2>
          <h3>4.1 Demande de réservation</h3>
          <p>
            La réservation s'effectue via le formulaire en ligne ou par contact direct. 
            Toute demande doit être confirmée par email.
          </p>
          
          <h3>4.2 Confirmation</h3>
          <p>
            La réservation n'est définitive qu'après confirmation écrite de notre part et versement d'un acompte.
          </p>

          <h2>5. Tarifs et paiement</h2>
          <h3>5.1 Tarifs</h3>
          <p>
            Les tarifs sont indiqués en euros, TTC. Ils correspondent à une location pour un weekend complet 
            (du vendredi soir au lundi matin).
          </p>
          
          <h3>5.2 Paiement</h3>
          <p>
            Le paiement s'effectue :
          </p>
          <ul>
            <li>50% d'acompte à la réservation</li>
            <li>50% restant au retrait du matériel</li>
          </ul>

          <h2>6. Retrait et retour du matériel</h2>
          <h3>6.1 Retrait</h3>
          <p>
            Le retrait s'effectue à notre adresse à Rhode-Saint-Genèse aux horaires convenus. 
            Le client doit disposer d'un véhicule avec hayon suffisant.
          </p>
          
          <h3>6.2 Retour</h3>
          <p>
            Le matériel doit être retourné propre et sec dans l'état initial. 
            Tout dommage ou salissure excessive sera facturé.
          </p>

          <h2>7. Utilisation et sécurité</h2>
          <h3>7.1 Responsabilité du client</h3>
          <p>
            Le client s'engage à :
          </p>
          <ul>
            <li>Respecter les consignes d'utilisation</li>
            <li>Assurer la surveillance permanente des enfants</li>
            <li>Vérifier les conditions météorologiques</li>
            <li>Ne pas dépasser la capacité maximale indiquée</li>
          </ul>
          
          <h3>7.2 Conditions d'utilisation</h3>
          <p>
            L'utilisation est interdite par :
          </p>
          <ul>
            <li>Vent supérieur à 40 km/h</li>
            <li>Pluie intense</li>
            <li>Températures négatives</li>
          </ul>

          <h2>8. Annulation</h2>
          <h3>8.1 Annulation par le client</h3>
          <ul>
            <li>Plus de 7 jours avant : remboursement de l'acompte</li>
            <li>Moins de 7 jours : acompte non remboursable</li>
            <li>Conditions météorologiques défavorables : report gratuit</li>
          </ul>
          
          <h3>8.2 Annulation par l'entreprise</h3>
          <p>
            En cas d'annulation de notre fait, l'acompte est intégralement remboursé.
          </p>

          <h2>9. Responsabilité et assurance</h2>
          <p>
            Notre responsabilité est limitée aux dommages directs causés par un défaut du matériel. 
            Le client est responsable des dommages causés aux tiers et doit s'assurer de disposer 
            d'une assurance responsabilité civile appropriée.
          </p>

          <h2>10. Protection des données personnelles</h2>
          <p>
            Le traitement des données personnelles est régi par notre 
            <Link to="/privacy-policy" className="text-primary hover:underline">
              Politique de Confidentialité
            </Link>.
          </p>

          <h2>11. Propriété intellectuelle</h2>
          <p>
            Tous les éléments du site (textes, images, logos) sont protégés par le droit d'auteur 
            et ne peuvent être reproduits sans autorisation.
          </p>

          <h2>12. Droit applicable et juridiction</h2>
          <p>
            Les présentes conditions sont soumises au droit belge. 
            Tout litige sera de la compétence exclusive des tribunaux de Bruxelles.
          </p>

          <h2>13. Médiation</h2>
          <p>
            En cas de litige, le client peut s'adresser au service de médiation pour les consommateurs : 
            <a href="https://www.odr.ec.europa.eu" target="_blank" rel="noopener noreferrer">
              www.odr.ec.europa.eu
            </a>
          </p>

          <h2>14. Dispositions diverses</h2>
          <p>
            Si une clause des présentes conditions est déclarée nulle, 
            les autres clauses restent applicables.
          </p>
          
          <p>
            Ces conditions peuvent être modifiées à tout moment. 
            La version applicable est celle en vigueur au moment de la commande.
          </p>

          <h2>15. Contact</h2>
          <p>
            Pour toute question concernant ces conditions :
          </p>
          <p>
            Email : lechateaudeclementine@gmail.com<br />
            Téléphone : +32-123-45-67-89<br />
            Adresse : Avenue de la Rosée 12, 1640 Rhode-Saint-Genèse
          </p>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;